const query = (id, isPreview) => `
{
    twoSectionLayout(id: "${id}", preview: ${isPreview}){
        sectionTitle
        middleContent
        imagePositionLeft
        imagePositionRight
        contentCollection(limit:10) {
          items {
            ...on TextContent {
              displayName
              title
              shortDescription
              content
              
              __typename
            }
            ...on SocialLinks {
              internalTitle
              __typename
              linkCollection(limit:10) {
                items {
                  name
                  url
                  label
                  images {
                    altText
                    imageDesktop {
                         title
                         description
                         contentType
                         fileName
                         size
                         url
                         width
                         height
                      }
                      imageMobile {
                              title
                              description
                              contentType
                              fileName
                              size
                              url
                              width
                              height
                        }
                  }
                }
              }
            }
            ...on Link {
              name
              url
              title
              label
              images {
                altText
                imageDesktop {
                  title
                  url
                }
              }
              __typename
            }
          }
        }
        variant
        imagePropsRight{
        altText
        imageMobile{
            url
          title
          description
        }
        imageDesktop{
            url
            description
          title
        }
        }
      imagePropsLeft{
        altText
        imageMobile{
            url
          title
          description
        }
        imageDesktop{
            url
            description
          title
        }
        }
        descriptionCollection{
        items{
            title
            shortDescription
          }
        }
    }
}
`

module.exports = { query }
